import { SupportedTLD } from '@eversports/react-app-base/tld-configs'

export const DEFAULT_CITY_SLUGS_BY_TLD: { [key in SupportedTLD]: string } = {
  at: 'wien',
  nl: 'amsterdam',
  de: 'berlin',
  es: 'barcelona',
  ch: 'zuerich',
  it: 'merano',
  be: 'bruxelles',
  fr: 'paris',
}

export const DEFAULT_SPORT_SLUGS_BY_TLD: { [key in SupportedTLD]: Array<string> } = {
  ch: ['yoga', 'pilates', 'reformer-pilates', 'fitness', 'krafttraining', 'poledance', 'tanzen', 'squash', 'lagree'],
  at: ['yoga', 'reformer-pilates', 'pilates', 'fitness', 'tennis', 'tanzen', 'boxen', 'barre', 'lagree'],
  de: ['yoga', 'fitness', 'pilates', 'tanzen', 'crossfit', 'reformer-pilates', 'hyrox', 'poledance', 'tennis'],
  fr: ['pilates', 'yoga', 'tanzen', 'fitness', 'poledance', 'reformer-pilates'],
  it: ['yoga', 'fitness', 'pilates'],
  be: ['yoga', 'pilates', 'tanzen', 'poledance', 'reformer-pilates', 'fitness'],
  nl: ['yoga', 'fitness', 'krafttraining', 'poledance', 'zirkeltraining', 'boxen', 'pilates', 'tanzen', 'meditation'],
  es: ['yoga', 'meditation', 'pilates', 'tanzen', 'fitness', 'reformer-pilates', 'poledance'],
}
